import React from "react";

// Shared dose-button grid used by the kept GLP-1 follow-up pathway (Q15) and Form B's
// own "what dose are you currently using?" question — both docs specify the same
// per-medication dose ladders (see GLP1_MEDICATIONS in eligibility-rules.js).
export default function DoseSelector({ doseOptions, selected, onSelect }) {
  if (!doseOptions || doseOptions.length === 0) {
    return <p className="text-sm text-gray-500">No fixed dose ladder for this medication.</p>;
  }

  return (
    <div className="flex flex-wrap gap-2">
      {doseOptions.map((dose) => (
        <button
          key={dose}
          type="button"
          onClick={() => onSelect(dose)}
          className={`px-4 py-2 rounded-lg border text-sm font-medium transition-colors
            ${selected === dose ? "bg-[#35C3D9] text-white border-[#35C3D9]" : "bg-white text-gray-800 border-sky-300"}`}
        >
          {dose}
        </button>
      ))}
    </div>
  );
}
